<template>
  <nav-bar title="部门监管工作落实情况统计明细" />
  <Content :bottom="0">
    <div class="title" >{{list.stName}}{{props.nTitle}}阅读情况明细</div>
    <div class="list-item" v-for="item in list.infoList" :key="item.streetCode">
      <p style="text-decoration: underline;color: blue" @click="handleClick(item)" >
        {{ item.streetName }}
      </p>
      <div>
        <span>应读：{{ item.planCount }}</span>
        <span >已读：{{ item.finishCount }}</span>
      </div>
    </div>
  </Content>
</template>

<script>
import { useStore } from 'vuex'
import { Dialog } from 'vant'
import {
  getNextOrgStat
} from '@/api/supervise'
import { computed, ref } from 'vue'
import { useGetData } from '@/hooks/useGetData'
export default {
  name: 'noticeInfo',
  props: ['nId', 'nTitle'],
  setup(props) {
    const store = useStore()
    const streetCode = computed(() => store.state.roleInfo.companyId)
    // 检查情况统
    const list = ref([])
    const level = ref()
    useGetData(getNextOrgStat, data => {
      list.value = data
      level.value = data.stLevel
    })({
      nId: props.nId,
      stId: streetCode.value
    })

    const handleClick = (item) => {
      if (level.value < 3) {
        useGetData(getNextOrgStat, data => {
          list.value = data
          level.value = data.stLevel
        })({
          nId: props.nId,
          stId: item.streetCode
        })
      } else {
        Dialog.alert({
          message: '明细数据只提供到街道级别。'
        }).then(() => {
          // on close
        })
      }
    }
    return {
      list,
      handleClick,
      props,
      level
    }
  }
}
</script>

<style lang="scss" scoped>
  .title {
    padding: 16px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  .title_l {
    padding: 12px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    background-color: #b6e6ff;
  }
  .checkNum {
    font-size: 14px;
    padding: 0 16px;
    color: #333;
  }
  .list-item {
    padding: 16px;
    background-color: #fff;
    margin-bottom: 10px;
    p {
      font-size: 15px;
      font-weight: 600;
      color: #333;
    }
    span {
      font-size: 14px;
      color: #666;
      margin-right: 16px;
    }
  }
  .detail {
    font-size: 14px;
    padding: 16px;
    background-color: #fff;
    span {
      margin-right: 10px;
    }
  }
</style>
